import { getGridNumericOperators } from '@mui/x-data-grid-pro'
import { FILTER_OPERATOR_LABELS, RELEVANT_NUMBER_OPERATORS } from '@shared/constants/dataGrid'

import { TraineeColumnType } from '../traineesDataGridColumns'

export const trainingYearColumnModel: TraineeColumnType = {
  field: 'trainingYear',
  width: 80,
  filterOperators: getGridNumericOperators().filter((operator) =>
    Object.keys(RELEVANT_NUMBER_OPERATORS).includes(operator.value)).map((operator) => ({
    ...operator,
    type: 'number',
    label: FILTER_OPERATOR_LABELS[operator.value as keyof typeof FILTER_OPERATOR_LABELS]
  })),
  type: 'number',
  align: 'left',
  headerAlign: 'left',
  valueGetter: (params) => params.row?.trainingYear
}
